module.exports = __webpack_public_path__ + "img/eye.ef878585.svg";